
interface LocaleLangInfo {
  code: string
  lang: string
  name: string
  iso: string
  countryCode: string
  currency: string
}

const LOCALES_LANG_INFO: { [key: string]: LocaleLangInfo } = {
  da: {
    code: 'da',
    lang: 'da',
    name: 'Dansk',
    iso: 'da-DK',
    countryCode: 'dk',
    currency: 'DKK',
  },
  no: {
    code: 'no',
    lang: 'nb',
    name: 'Norsk',
    iso: 'nb-NO',
    countryCode: 'no',
    currency: 'NOK',
  },
  en: {
    code: 'en',
    lang: 'en',
    name: 'English',
    iso: 'en-US',
    countryCode: 'us',
    currency: 'USD',
  },
  pl: {
    code: 'pl',
    lang: 'pl',
    name: 'Polski',
    iso: 'pl-PL',
    countryCode: 'pl',
    currency: 'PLN',
  },
  'zh-cn': {
    code: 'zh-cn',
    lang: 'zh-cn',
    name: '中國',
    iso: 'zh-CN',
    countryCode: 'cn',
    currency: 'CNY',
  },
  sv: {
    code: 'sv',
    lang: 'sv',
    name: 'Svenska',
    iso: 'sv-SE',
    countryCode: 'se',
    currency: 'SEK',
  },
}

const SWEDISH_LOCALES = ['sv', 'zz', 'zt', 'xx']

const NORWEGIAN_LANG_CODES = ['no', 'nb', 'nn']

export {
  LOCALES_LANG_INFO,
  SWEDISH_LOCALES,
  NORWEGIAN_LANG_CODES,
}
